import { computed, toValue, type MaybeRefOrGetter, type Ref } from 'vue';
import { useToursActivities } from '@/entities/tour-activities';
import type { GroupIn, Chip } from '@/entities/tour-activities';

export const useToursActivitiesAsChipsGroups = (
  activityCounts?: MaybeRefOrGetter<Record<string, number> | null | undefined>,
): Ref<GroupIn[]> => {
  const { toursActivities } = useToursActivities();

  const groups = computed<GroupIn[]>(() => {
    const map = new Map<string, Chip[]>();
    const counts = toValue(activityCounts);

    for (const a of toursActivities.value) {
      const title = a.categoryTitle || '';
      const list = map.get(title) ?? [];
      const count = counts?.[a.id ?? ''] ?? 0;

      if (count > 0) {
        list.push({
          label: a.name ?? '',
          value: a.slug ?? '',
          id: a.id,
          count,
        });
      }

      map.set(title, list);
    }

    return Array.from(map.entries())
      .map(([title, tags]) => ({ title, tags }))
      .filter((group) => group.tags.some((tag) => tag.count && tag.count > 0));
  });

  return groups as Ref<GroupIn[]>;
};
